








import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { SortOrder } from "@/shared/types";

@Component({
  computed: {
    SortOrder () {
      return SortOrder;
    }
  }
})
export default class SortIcon extends Vue {

  @Prop({ default: SortOrder.None })
  sortOrder: SortOrder;

}
